module.exports = __webpack_public_path__ + "static/media/Youtube icon.d6b08677.svg";